import { render, staticRenderFns } from "./faturamentoChart.vue?vue&type=template&id=bebf2d5e&scoped=true"
import script from "./faturamentoChart.vue?vue&type=script&lang=js"
export * from "./faturamentoChart.vue?vue&type=script&lang=js"
import style0 from "./faturamentoChart.vue?vue&type=style&index=0&id=bebf2d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebf2d5e",
  null
  
)

export default component.exports